export default {
    userName: '',
    userInfoModal: false,
};
